import { HugeiconsIcon } from '@hugeicons/react';
import Link from 'next/link';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa6';
import { SearchVisualIcon } from '@hugeicons/core-free-icons';
import { getPathFromUrl } from '@/utils/getPathFromUrl';

const BrowseCategories = ({ data, topBarMessage, hasTopBar,  isSticky }: any) => {

  const dynamicTop = hasTopBar ? '210px' : '170px';

  return (
    <div className="header__Categories d-none d-xl-block">
      <nav className="menu">
        <ul className="menu-section">
          <li className="menu-item-has-children ms-0">
            <Link href="#" className="d-flex align-items-center">
              {/* <span>
                <HugeiconsIcon
                  icon={DashboardSquare01Icon}
                  size={18}
                  strokeWidth={1.5}
                />
              </span> */}
              Browse Categories <FaAngleDown />
            </Link>
            <div
              className="submenu"
              style={{ top: dynamicTop }}
            >
              <ul>
                {data?.sidebarList?.map((cat: any) => {
                  const url = getPathFromUrl(cat?.url);
                  return (
                    <li key={cat?.id}>
                      <Link href={`${url}`}>
                        <span>
                          {/* <HugeiconsIcon icon={SearchVisualIcon} size={16} /> */}
                        </span>{' '}
                        {cat?.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default BrowseCategories;
